// This function allow to reference async chunks
__webpack_require__.k = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + "1d49de93152b023f51d3" + ".css";
};